var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "#868686",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(201 -256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-201 256)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 1.112 17.778C 1.11358 18.3668 1.3482 18.9311 1.76456 19.3474C 2.18092 19.7638 2.74518 19.9984 3.334 20L 12.222 20C 12.8108 19.9984 13.3751 19.7638 13.7914 19.3474C 14.2078 18.9311 14.4424 18.3668 14.444 17.778L 14.444 4.444L 1.112 4.444L 1.112 17.778ZM 15.556 1.112L 11.666 1.112L 10.556 0L 5 0L 3.89 1.112L -6.86646e-08 1.112L -6.86646e-08 3.334L 15.556 3.334L 15.556 1.112Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.3cde89ace49f1737445f3a343e632223.svg";
export { ForwardRef as ReactComponent };